import { render, staticRenderFns } from "./CustomPagination.vue?vue&type=template&id=6c68ad2f&scoped=true"
import script from "./CustomPagination.vue?vue&type=script&lang=js"
export * from "./CustomPagination.vue?vue&type=script&lang=js"
import style0 from "./CustomPagination.vue?vue&type=style&index=0&id=6c68ad2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c68ad2f",
  null
  
)

export default component.exports